<div class="layout-auto-1" *ngIf="workspace">
	<div class="app-pad-top_025">
		<ng-container *ngIf="!reviewEditMode">
			<ng-container *ngIf="canEdit
											&& workspace.receiptData.rcpt_enmIdent_ReceiptStatus < 10
											&& workspace.receiptData.rcpt_enmIdent_ReceiptStatus !== 3">
				<div class="app-list-acceptbox-accepted bg-green grid-1-auto" *ngIf="conditions.visibleConditions().length > 0 && conditions.acceptedAll()">
					<p>Hinweise & Warnungen gelesen und akzeptiert!</p>
					<div>
						<button (click)="conditions.reset()"
						        class="md-btn">
							{{getGlobal('reset')}}
						</button>
					</div>
				</div>
				<div class="app-list-acceptbox" *ngIf="conditions.visibleConditions().length > 0 && !conditions.acceptedAll()">
					<div class="list-header typo-small">
						{{conditions.header}}
					</div>
					<ng-container *ngFor="let condition of conditions.data; index as i">
						<div class="list-row list-row-auto-1-auto typo-small"
						     *ngIf="condition.showCondition">
							<div class="list-icon" style="margin-right: 0">
								<i class="far fa-check-circle"
								   [class.c-red]="!condition.accepted"
								   [class.c-green]="condition.accepted">
								</i>
							</div>
							<div class="list-two-line ">
				        <span class="list-primary-text typo-small"
				              style="font-size: 14px"
				              [innerText]="condition.condition">
				        </span>
								<span class="list-secondary-text typo-small"
								      style="font-size: 12px"
								      [innerText]="condition.hint">
	              </span>
							</div>
							<div class="typo-right">
								<exg-switch *ngIf="condition.showAccept"
								            [(ngModel)]="condition.accepted">
								</exg-switch>
							</div>
						</div>
					</ng-container>
				</div>
			</ng-container>
		</ng-container>
	</div>
	<div class="content app-pad-top_1 layout-auto-1-auto">
		<div>
			<exg-panel #VCExgPanelReasons [caption]="enumSvc.getFieldCaption('Receipt','rcptReviewReasons') + (reviewReason && reviewReason.length > 0  ? ': ' + reviewReason : '')">
				<ng-template #content>
					<ng-container *ngFor="let enm of getrcptReviewReasonList(); let i = index;">
						<exg-switch style="align-self: start; overflow: visible"
						            disabled="{{!canEdit || !reviewEditMode}}"
						            [caption]="enm.enmText"
						            [(ngModel)]="enm.enmValue"
						            (ngModelChange)="updateReviewReasons(enm)"
						            [tooltip]="enm.uiTooltip">
						</exg-switch>
					</ng-container>
				</ng-template>
			</exg-panel>
			<exg-panel [caption]="enumSvc.getFieldCaption('Receipt','rcptReviewHints') + (hintCount >= 1 ? ': ' + hintCount + ' Hinweis(e)' : '')">
				<ng-template #content>
					<ng-container *ngFor="let enm of getrcptReviewHintList(); let i = index;">
						<exg-switch style="align-self: start; overflow: visible"
						            disabled="{{!canEdit || !reviewEditMode}}"
						            [caption]="enm.enmText"
						            [(ngModel)]="enm.enmValue"
						            (ngModelChange)="updateReviewHints(enm)"
						            [tooltip]="enm.uiTooltip">
						</exg-switch>
					</ng-container>
				</ng-template>
			</exg-panel>
		</div>
		<div class="app-space-bottom"
		     *ngIf="MCEinit">
			<div class="app-label">
				{{enumSvc.getFieldCaption('Receipt', 'rcptExamComment')}}
			</div>
			<editor #VCCommentEditor name="CommentEditor"
			        *ngIf="reviewEditMode"
			        class="content app-editor"
			        [init]="MCEinit"
			        [(ngModel)]="reviewClone.rcptReviewComment">
			</editor>
			<editor #VCCommentViewer name="CommentViewer"
			        *ngIf="!reviewEditMode"
			        class="content app-editor"
			        [init]="MCEinitDisabled" [disabled]="true"
			        [(ngModel)]="reviewClone.rcptReviewComment">
			</editor>
			<p class="typo-small"  *ngIf="review.rcptReviewTextLCD">
				{{review.rcptReviewTextLCD | excDate}} {{review.rcptReviewTextLCU && review.rcptReviewTextLCU.length > 0 ? '(' + review.rcptReviewTextLCU + ')' : ''}}
			</p>
			<div></div>
<!-- 			<ng-container *ngIf="!reviewEditMode"> -->
<!-- 				<div> -->
<!-- 					<h4 class="typo-small">{{enumSvc.getFieldCaption("Receipt", "rcptExamComment")}}:</h4> -->
<!-- 					<p [innerText]="workspace.receiptData?.rcptReviewComment" -->
<!-- 					   class="md-textarea app-space-right app-space-left typo-small content app-space-top_1 height-auto-fit"> -->
<!-- 					</p> -->
<!-- 				</div> -->
<!-- 			</ng-container> -->
		</div>

    <!--Add Tables Flag Switch-->
    <div class="grid cols-2 app-space-top_1p5" style="padding-top: 1.4rem">
        <exg-checkbox [(ngModel)]="reviewClone.rcptSumTable"
                    disabled="{{!canEdit || !reviewEditMode}}"
                      [tooltip]="getRessource('tooltips.SumTable')"
                      flow="left"
                    caption="{{getRessource('tables.SumTable')}}"
                    class=""></exg-checkbox>
        <exg-checkbox [(ngModel)]="reviewClone.rcptPosTable"
                    disabled="{{!canEdit || !reviewEditMode}}"
                      [tooltip]="getRessource('tooltips.PosTable')"
                      flow="left"
                    caption="{{getRessource('tables.PosTable')}}"
                    class=""></exg-checkbox>
    </div>

    <!--rcptCommentNext-->
		<div class="" style="padding-top: 1.4rem">
			<exg-panel [caption]="enumSvc.getFieldCaption('Receipt','rcptCommentNext')">
				<ng-template #content>
					<exg-textarea [(ngModel)]="reviewClone.rcptCommentNext"
					              [maxlength]="5000"
					              caption=""
					              disabled="{{!canEdit || !reviewEditMode}}"
                        #VCComment name="Comment">
					</exg-textarea>
					<div class="spawn-reverse app-textcount">
						<span style="top: -2.75rem">(Zeichen: {{reviewClone.rcptCommentNext.length}}{{' | ' + 5000}})</span>
					</div>
				</ng-template>
			</exg-panel>
		</div>
	</div>
</div>
